import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { GenesisUnitOfWork } from '../../core/core.module';
import _ from 'lodash';

@Component({
    selector: 'app-shipping-address-dialog',
    templateUrl: './shipping-address-dialog.component.html',
    styleUrls: ['./shipping-address-dialog.component.scss'],
    standalone: false
})
export class ShippingAddressDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();

    shipAddress: any;
    states: any;
    countries: any[] = ['US', 'OTHER'];
    selectedOtherCountry: any;
    dealer: any;

    mode: 'default' | 'invoice' = 'default';
    // invoice: Invoice;
    showCopyBilling = false;
    showAddressSelect = false;
    addresses: any[];
    selectedAddress: any;

    constructor(private uow: GenesisUnitOfWork, public modalRef: BsModalRef) {}

    async ngOnInit() {
        this.states = this.uow.lookups.states;

        if (!this.shipAddress) {
            this.shipAddress = this.uow.shipAddresses.createEntity();
            this.shipAddress.state = 'MI';
            this.shipAddress.country = 'US';
            this.shipAddress.dealer = this.dealer;
        }
        this.shipAddress.companyName = this.dealer.companyName;
    }

    selectedAddressChange(e) {
        if (this.selectedAddress) {
            this.shipAddress.companyName = this.selectedAddress.companyName;
            this.shipAddress.contactName = this.selectedAddress.contactName;
            this.shipAddress.address1 = this.selectedAddress.address1;
            this.shipAddress.address2 = this.selectedAddress.address2;
            this.shipAddress.city = this.selectedAddress.city;
            this.shipAddress.state = this.selectedAddress.state;
            this.shipAddress.zIP = this.selectedAddress.zIP;
            this.shipAddress.country = this.selectedAddress.country;
            this.shipAddress.phoneNumber = this.selectedAddress.phoneNumber;
            this.shipAddress.phoneNumber2 = this.selectedAddress.phoneNumber2;
        }
    }

    async save() {
        if (this.mode === 'invoice') {
            // this.invoice.shipCompanyName = this.shipAddress.companyName;
            // this.invoice.shipContactName = this.shipAddress.contactName;
            // this.invoice.shipAddress1 = this.shipAddress.address1;
            // this.invoice.shipAddress2 = this.shipAddress.address2;
            // this.invoice.shipCity = this.shipAddress.city;
            // this.invoice.shipState = this.shipAddress.state;
            // this.invoice.shipZIP = this.shipAddress.zIP;
            // this.invoice.shipCountry = this.shipAddress.country;
            // this.invoice.shipPhoneNumber = this.shipAddress.phoneNumber;
            // this.invoice.shipPhoneNumber2 = this.shipAddress.phoneNumber2;
        } else {
        }
        await this.uow.commit([this.shipAddress]);
        this.result.next(true);
        this.modalRef.hide();
    }

    copyBilling() {
        // this.shipAddress.companyName = this.invoice.billCompanyName;
        // this.shipAddress.contactName = this.invoice.billContactName;
        // this.shipAddress.address1 = this.invoice.billAddress1;
        // this.shipAddress.address2 = this.invoice.billAddress2;
        // this.shipAddress.city = this.invoice.billCity;
        // this.shipAddress.state = this.invoice.billState;
        // this.shipAddress.zIP = this.invoice.billZIP;
        // this.shipAddress.country = this.invoice.billCountry;
        // this.shipAddress.phoneNumber = this.invoice.billPhoneNumber;
    }

    cancel(): void {
        this.shipAddress.entityAspect.rejectChanges();
        this.result.next(false);
        this.modalRef.hide();
    }
}
